// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import $api from './api/axios'
import storage from './api/storage'
import axios from 'axios'  // 安装axios后引入

Vue.prototype.$axios = axios  // 将axios挂载到原型上方便使用

// vue中导出excel表格模板
import FileSaver from 'file-saver'
//import XLSX from 'xlsx'

//Vue.prototype.$FileSaver = FileSaver; //设置全局
//Vue.prototype.$XLSX = XLSX; //设置全局

Vue.config.productionTip = false
Vue.use(elementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js